module.exports = "<div class=\"modal-header modal-header--legend\">\n  <h4 class=\"pull-left modal-title modal-title-map text-uppercase\">\n    <i class=\"fa fa-map-o fa-1x\"></i>&nbsp;&nbsp;<span>LEGEND</span>\n  </h4>\n  <i ng-click=\"$ctrl.closeModal()\" class=\"map-legend-close-btn fa fa-times-circle fa-2x pull-right\" aria-hidden=\"true\"></i>\n\n</div>\n<div class=\"modal-body map-legend\">\n    <li><img height=\"25\" src=\"../../../assets/icons/map-legends-icons/viewpoint-location.png\">&nbsp;&nbsp;Viewpoint Location</li>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/modal/info/modal.html
// module id = 121
// module chunks = 0